export function MD_Icon() {
  return (
    <svg width="48" height="30" viewBox="0 0 48 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_14954_10846)">
        <path d="M46.518 28.4894H1.51229V1.51057H46.518V28.4894ZM0 30H48V0H0V30Z" fill="black" fillOpacity="0.8" />
        <path
          d="M5.20227 24.3505V5.61934H10.8582L14.276 18.3988L17.6333 5.61934H23.3195V24.3505H19.7807V9.60725L16.0605 24.3505H12.431L8.71078 9.60725V24.3505H5.20227Z"
          fill="black"
          fillOpacity="0.8"
        />
        <path
          d="M30.8507 8.79154V21.148H33.6938C34.4474 21.2352 35.2086 21.2352 35.9622 21.148C36.5358 21.0241 37.0674 20.7534 37.5047 20.3625C37.9836 19.8509 38.3267 19.2278 38.5028 18.5498C38.7797 17.4236 38.9018 16.2649 38.8658 15.1057C38.9023 13.9765 38.7802 12.8476 38.5028 11.7523C38.2935 11.0683 37.9196 10.446 37.414 9.93957C36.9226 9.48962 36.3149 9.18611 35.6597 9.06344C34.659 8.91288 33.6468 8.85221 32.6352 8.88217L30.8507 8.79154ZM27.2212 5.61933H34.1475C35.3002 5.61321 36.4489 5.75537 37.5652 6.04229C38.636 6.36398 39.6051 6.95727 40.3781 7.76434C41.19 8.63191 41.8086 9.66161 42.1928 10.7855C42.6118 12.1868 42.8158 13.6434 42.7977 15.1057C42.8769 16.4711 42.7235 17.84 42.344 19.1541C41.9363 20.4041 41.2424 21.5419 40.3176 22.4773C39.5582 23.1716 38.6467 23.6785 37.656 23.9577C36.5736 24.2578 35.4515 24.3903 34.3289 24.3504H27.2212V5.61933Z"
          fill="black"
          fillOpacity="0.8"
        />
      </g>
      <defs>
        <clipPath id="clip0_14954_10846">
          <rect width="48" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
